document.addEventListener("alpine:init", () => {
    Alpine.data("contentSwitcher", () => ({
        currentContent: "0",
        height: 0,
        contentContainer: null,
        init() {
            this.contentContainer = this.$el.querySelector(
                ".Content__Switcher__content"
            );
            pegasus.onResizeFinished(() => {
                this.height = 0;
                this.equalHeight(".Content__Switcher__item");
            }, true);
        },
        equalHeight(element) {
            const _this = this;
            document.querySelectorAll(element).forEach(function (el) {
                if (el.scrollHeight > _this.height) {
                    _this.height = el.scrollHeight;
                }
            });
            console.log(this.contentContainer);
            this.contentContainer.style.height = this.height + "px";
        },
    }));
});
